import React from 'react';
import Services from '../HomePage/Services/Services';
import Navbar from '../ShareComponents/Navbar/Navbar';

const ServicePage = () => {
    return (
        <div>
            <Navbar />
            <Services />
        </div>
    );
};

export default ServicePage;